export const getHashValue = (initialHashValue: string): string => initialHashValue.replace('#', '');
export const getHashValueSlices = (initialHashValue: string): string[] => initialHashValue.split('/');

export const getPathPrefix = (path: string, segmentCount: number): string => {
  if (!path) {
    return '';
  }

  if (segmentCount == 0) {
    return path.startsWith('/') ? '/' : '';
  }

  if (segmentCount > 0) {
    const limit = path.startsWith('/') ? segmentCount + 1 : segmentCount;
    const segments = path.split('/', limit);
    return segments.slice(0, limit).join('/');
  }

  return '';
};

export function getBaseDomain(hostname: string): string | undefined {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  const parts = host.split('.');
  const isIpAddress = host.includes(':') || parts.every((part) => /^\d+$/.test(part));

  if (parts.length < 2 || isIpAddress) {
    return undefined;
  }

  // Strip only the subdomain, so multi-part public suffixes such as co.uk stay intact.
  return parts.slice(parts.length > 2 ? 1 : 0).join('.');
}
